import React from 'react';
import { WT_TOKENS } from '../../warm-transfer/config';
import type { WarmTransferHeaderStats } from '../../warm-transfer/types';
import { Icon } from '../Icon/Icon';

export interface WarmTransferPageHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  stats: WarmTransferHeaderStats;
}

export function WarmTransferPageHeader({
  search,
  onSearchChange,
  stats,
}: WarmTransferPageHeaderProps) {
  return (
    <section className="wt-fade-up wt-d-0 mb-[22px] flex items-end justify-between gap-6 pt-1">
      <div className="min-w-0 flex-1">
        <div className="mb-2.5 flex items-center gap-2">
          <Icon kind="phone" size={13} color={WT_TOKENS.green} stroke={2} />
          <span
            className="text-[11px] font-bold uppercase tracking-[0.14em]"
            style={{ color: WT_TOKENS.green }}
          >
            Patients waiting
          </span>
        </div>
        <h1 className="m-0 text-[48px] font-semibold leading-none tracking-[-0.035em] text-[var(--ink-0)]">
          Warm <span className="wt-count-gradient">transfer</span>
        </h1>
        <p className="mt-3 text-[14px] tracking-[-0.005em] text-[var(--ink-2)]">
          {stats.waiting} {stats.waiting === 1 ? 'patient' : 'patients'} waiting right now
          <span className="text-[var(--ink-2)] opacity-60"> · </span>
          <span className="font-bold text-[var(--ink-0)]">longest wait {stats.longest}</span>
        </p>
      </div>
      <div className="relative flex-none">
        <Icon
          kind="search"
          size={14}
          color={WT_TOKENS.ink4}
          stroke={2}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
        />
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search transfers…"
          className="h-9 w-[280px] rounded-[10px] border border-[var(--cream-2)] bg-[var(--cream-1)] py-0 pl-9 pr-3 text-[13px] tracking-[-0.005em] text-[var(--ink-0)] shadow-[var(--sh-1)] outline-none"
        />
      </div>
    </section>
  );
}
